import { render, staticRenderFns } from "./category-mobile.vue?vue&type=template&id=57939ca6&lang=pug"
import script from "./category-mobile.vue?vue&type=script&lang=coffee"
export * from "./category-mobile.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports